import { render, staticRenderFns } from "./OrderWizard.vue?vue&type=template&id=e70bad98&scoped=true&"
import script from "./OrderWizard.vue?vue&type=script&lang=js&"
export * from "./OrderWizard.vue?vue&type=script&lang=js&"
import style0 from "./OrderWizard.vue?vue&type=style&index=0&id=e70bad98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70bad98",
  null
  
)

export default component.exports